import React, { useRef, useEffect, forwardRef } from "react";
import { Input } from "@activecollab/components";

export const InputWithSelectedText = forwardRef((props, ref) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.select();
  }, []);

  return (
    <Input
      {...props}
      ref={(el) => {
        inputRef.current = el;
        if (ref) return (ref.current.name = el);
      }}
    />
  );
});

InputWithSelectedText.displayName = "InputWithSelectedText";
